<template>
    <div class="filter ">
        <div class="all-filters" @click="filtersClicked">
            <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" class="">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M3.75 2a.75.75 0 0 1 .75.75v5.503a.75.75 0 1 1-1.5 0V2.75A.75.75 0 0 1 3.75 2ZM10 2a.75.75 0 0 1 .75.75V6.5H12A.75.75 0 0 1 12 8H8a.75.75 0 0 1 0-1.5h1.25V2.75A.75.75 0 0 1 10 2Zm6.25 0a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0v-7.5a.75.75 0 0 1 .75-.75ZM10 9.5a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7A.75.75 0 0 1 10 9.5Zm-9 1.75a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H4.5v5.25a.75.75 0 0 1-1.5 0V12H1.75a.75.75 0 0 1-.75-.75Zm12.5 2a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H17v3.25a.75.75 0 0 1-1.5 0V14h-1.25a.75.75 0 0 1-.75-.75Z"
                    fill="#333"></path>
            </svg>
            <span>Все фильтры</span>
        </div>
        <Transition name="fade">
            <div v-show="isListVisible" class="all-filters__options">
                <div>
                    <h5>Расположение</h5>
                    <v-select v-for="selectInfo, number in LocationFilters" ref="locatonSelects"
                        :select-name="selectInfo.name" :selectId="number + 10" :options="selectInfo.value"
                        :selectSet="selectInfo.isSet" :selected="selectInfo.translation"
                        @select="filterSelected"></v-select>
                </div>
                <div>
                    <h5>Дом</h5>
                    <v-select v-for="selectInfo, number in HouseFilters" ref="houseSelects" :select-name="selectInfo.name"
                        :selectId="number + 20" :options="selectInfo.value" :selectSet="selectInfo.isSet"
                        :selected="selectInfo.translation" @select="filterSelected"></v-select>
                </div>
                <div>
                    <h5>Квартира</h5>
                    <v-select v-for="selectInfo, number in ApartmentFilters" ref="apartmentSelects"
                        :select-name="selectInfo.name" :selectId="number + 20" :options="selectInfo.value"
                        :selectSet="selectInfo.isSet" :selected="selectInfo.translation"
                        @select="filterSelected"></v-select>
                </div>
                <div class="all-filters__options__button-container">
                    <button @click="resetForm" type="button" class="reset-button">Сбросить
                        фильтры</button>
                    <button @click="hideFilters" type="button" class="reset-button close-button">Свернуть</button>
                    <button @click="search" type="button" class="search-button">Найти</button>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
import VSelect from "@/components/v-select.vue";

export default {
    name: 'all-Filters',
    components: {
        VSelect,
    },
    props: {
        LocationFilters: {
            type: Array,
            default() {
                return []
            }
        },
        HouseFilters: {
            type: Array,
            default() {
                return []
            }
        },
        ApartmentFilters: {
            type: Array,
            default() {
                return []
            }
        },
        isResetShow: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    emits: ['select', 'search', 'filtersOpen', 'filterResets'],
    data() {
        return {
            isListVisible: false,
        }
    },

    created() {
        window.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.hideFilters()
            }
        })
    },

    beforeUnmount() {
        window.removeEventListener("click", (e) => {
            if (!this.$el.contains(e.target)) {
                this.hideFilters()
            }
        });
    },

    methods: {
        filtersClicked() {
            this.isListVisible = !this.isListVisible
            if (this.isListVisible === true) {
                this.$emit('filtersOpen', true)
            }
            else {
                this.$emit('filtersOpen', false)
            }
        },
        selectFilter(option) {
            this.$emit('select', option);
        },
        hideFilters() {
            this.isListVisible = false;
            this.$emit('filtersOpen', false)
        },
        search() {
            this.$emit('search');
            this.hideFilters()
        },
        filterSelected(option) {
            this.$emit('select', option);
        },
        resetForm() {
            this.$emit('filterResets');

            for (let select of this.$refs.apartmentSelects) {
                select.clear();
            }

            for (let select of this.$refs.houseSelects) {
                select.clear();
            }

            for (let select of this.$refs.locatonSelects) {
                select.clear();
            }
        },
        checkForm() {
            for (let select of this.$refs.apartmentSelects) {
                select.checkList(this.$parent.filterValues);
            }

            for (let select of this.$refs.houseSelects) {
                select.checkList(this.$parent.filterValues);
            }

            for (let select of this.$refs.locatonSelects) {
                select.checkList(this.$parent.filterValues);
            }
        }
    }
}
</script>

<style lang="scss">
.all-filters {
    display: flex;
    align-items: center;
    @extend %BODY1;

    width: 150px;

    cursor: pointer;


    >span {
        margin-left: 10px;
    }

    &__options {
        position: absolute;

        width: 100%;
        left: 0;
        top: 70px;

        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 50px;

        padding: 25px 20px;

        background: $white;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08);
        border-radius: 15px;

        z-index: 5;

        h5 {
            @extend %BODY1;
            font-weight: 500;
        }

        .v-select {
            margin-top: 20px;

            .checked {
                background-color: $main-color;
            }
        }

        .v-select__container {
            width: 100%;
            background-color: rgb(238, 238, 238);
        }

        .v-select__options {
            width: 100%;
            min-width: 100%;
        }

        &__button-container {
            margin-top: 30px;

            display: flex;
            justify-content: space-between;
            grid-column: 1/4;
        }

        .search-button {
            padding: 15px 75px;
            background-color: $button-color;
            color: white;
            border-radius: 15px;

            @extend %BODY1;
            position: static;
            margin-left: auto;
        }

        .reset-button {
            position: static;

            padding: 15px 25px;
            background-color: rgba(204, 204, 204, 0.774);
            color: $font-color;

            @extend %BODY1;

            border-radius: 15px;

            width: 170px;
        }

        .close-button {
            margin-left: 20px;
            background-color: rgba(163, 163, 163, 0.774);
        }
    }

}

@media screen and (max-width: 1200px) {
    .all-filters {
        &__options {
            top: 105px;
        }
    }
}

@media screen and (max-width: 800px) {
    .all-filters {
        &__options {
            display: flex;
            flex-direction: column;
            top: 190px;

            >div:not(:first-of-type) {
                margin-top: 20px;
            }

            .close-button {
                margin-left: 0;
                order: 2;

                margin-top: 15px;
            }

            &__button-container {
                flex-direction: column;
            }

            .search-button {
                width: 100%;

                margin-top: 15px;
            }
        }
    }
}
</style>